module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-input', {
    staticClass: "filter-search",
    attrs: {
      "placeholder": _vm.placeholder,
      "icon": "close",
      "on-icon-click": _vm.clear,
      "auto-complete": "on"
    },
    model: {
      value: (_vm.inner_value),
      callback: function($$v) {
        _vm.inner_value = $$v
      },
      expression: "inner_value"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15496df9","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/filters/FilterSearch.vue
// module id = 347
// module chunks = 0